type Props = { locale: string };

const TITLE: Record<string, string> = {
  en: "About Hantavirus.app",
  ar: "حول موقع هانتا",
  fr: "À propos d'Hantavirus.app",
};

const BODY: Record<string, string> = {
  en: "Hantavirus.app is an open public health surveillance tool. We aggregate hantavirus case reports from official sources (WHO, CDC, PAHO, ProMED) and present them with full provenance — every numeric field on this site has a source URL and a verified-at timestamp.",
  ar: "هانتا هو موقع عام لمراقبة الصحة العامة. نقوم بجمع تقارير حالات فيروس هانتا من مصادر رسمية ونعرضها مع توثيق كامل لمصادرها.",
  fr: "Hantavirus.app est un outil ouvert de surveillance de santé publique. Nous agrégeons les rapports de cas d'hantavirus de sources officielles et les présentons avec une traçabilité complète.",
};

export { Page };

function Page({ locale }: Props) {
  return (
    <main id="main-content">
      <h1>{TITLE[locale] ?? TITLE.en}</h1>
      <p>{BODY[locale] ?? BODY.en}</p>
    </main>
  );
}
